import { ApiResponse } from '@/domain'
import { backendApi } from '../backendApi'
import { DeathData } from '@/domain/deathData/deathData'

export const deathDataApi = {
  getDeathDataByContract: (contractId: string) =>
    backendApi.get<ApiResponse<DeathData[]>>(`/api/v1/data/agreements/${contractId}/deaths`).then((res) => res.data.data),

  getDeathData: (id: string) =>
    backendApi.get<ApiResponse<DeathData>>(`/api/v1/data/deaths/${id}`).then((res) => res.data.data),

  createDeathData: (data: DeathData) =>
    backendApi.post<ApiResponse<DeathData>>('/api/v1/data/deaths', data).then((res) => res.data.data),

  updateDeathData: (id: string, data: Partial<DeathData>) =>
    backendApi.put<ApiResponse<DeathData>>(`/api/v1/data/deaths/${id}`, data).then((res) => res.data.data),

  deleteDeathData: (id: string) =>
    backendApi.delete<ApiResponse<void>>(`/api/v1/data/deaths/${id}`).then((res) => res.data.data),
}
